import script from "./AutoGenerateCaptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoGenerateCaptionModal.vue?vue&type=script&setup=true&lang=js"

import "./AutoGenerateCaptionModal.vue?vue&type=style&index=0&id=6619cbdc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6619cbdc"]])

export default __exports__